(function () {
  const HIDE_STYLE_ID = "hide-utm-fields";

  // Get UTM params from URL
  function getUTMParams() {
    const utmFields = [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
      "utm_id",
    ];
    const params = {};
    const urlParams = new URLSearchParams(window.location.search);
    for (const field of utmFields) {
      if (urlParams.has(field)) {
        params[field] = urlParams.get(field);
      }
    }
    return params;
  }

  // Fill hidden UTM inputs in the Shopify form embed if present
  function fillUTMInputs(el, utmParams) {
    if (!el.shadowRoot) return;

    for (const [field, value] of Object.entries(utmParams)) {
      // Shopify Forms input IDs are escaped like custom#utm_source to custom\\#utm_source
      const input = el.shadowRoot.querySelector(`input#custom\\#${field}`);
      if (input && typeof value === "string") {
        input.value = value;
        // Dispatch input and change events in case the form is listening
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  const injectStyles = (el) => {
    if (!el.shadowRoot) return;

    if (el.shadowRoot.querySelector(`style[data-${HIDE_STYLE_ID}]`)) return;

    const style = document.createElement("style");
    style.setAttribute(`data-${HIDE_STYLE_ID}`, "1");
    style.textContent = `
      /* Hide the parent container div that contains these inputs */
      div:has(> input#custom\\#utm_source),
      div:has(> input#custom\\#utm_medium),
      div:has(> input#custom\\#utm_campaign),
      div:has(> input#custom\\#utm_term),
      div:has(> input#custom\\#utm_content),
      div:has(> input#custom\\#utm_id) {
        display: none !important;
      }
    `;
    el.shadowRoot.appendChild(style);
  };

  const watchShadow = (el, utmParams) => {
    if (!el.shadowRoot) return;

    injectStyles(el);
    fillUTMInputs(el, utmParams);

    // If new nodes are added inside the shadow DOM, re-apply fill
    const shadowObserver = new MutationObserver(() => {
      injectStyles(el);
      fillUTMInputs(el, utmParams);
    });
    shadowObserver.observe(el.shadowRoot, {
      childList: true,
      subtree: true,
    });
  };

  const utmParams = getUTMParams();

  const watchForEmbed = () => {
    const embed = document.querySelector("shopify-forms-embed");
    if (embed) {
      watchShadow(embed, utmParams);
      return true;
    }
    return false;
  };

  // 1️⃣ Try immediately
  if (watchForEmbed()) return;

  // 2️⃣ Observe DOM for lazy-loaded embed
  const domObserver = new MutationObserver(() => {
    if (watchForEmbed()) domObserver.disconnect();
  });

  domObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
